<header class="header">
  <div class="container-fluid">
    <button (click)="toggleSidebar()"
      [ngClass]="statusClass"
      class="btn btn-link primary-menu-toggle">
      <i class="fa-solid" [ngClass]="isSidebarOpen ? 'fa-xmark' : 'fa-bars'"></i>
    </button>

    <a (click)="goToDashboard($event)" class="logo" href="#"></a>

    <div class="secondary-menu">
      <div #dropUser="ngbDropdown" class="d-inline-flex user-menu" ngbDropdown>
        <button class="btn btn-link text-white" id="dropdownUser" ngbDropdownToggle>
          <div class="d-none d-sm-inline-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-user mr-2"></i>
            <span [innerText]="userDisplayName" class="d-inline"></span>
          </div>
          <i class="d-sm-none fa-solid fa-circle-user"></i>
        </button>
        <div aria-labelledby="dropdownUser" class="dropdown-user-menu" ngbDropdownMenu>
          <div class="user-menu-account">
            <div class="form-row flex-nowrap align-items-center">
              <div class="col-auto">
                <i class="fa-solid fa-circle-user h1 m-0"></i>
              </div>
              <div class="col">
                <strong [innerText]="userMail" class="d-block text-nowrap"></strong>
                <span [innerText]="userRole" class="text-lowercase text-capital-first-letter text-muted">
                </span>

              </div>
              <div class="col-auto">
                <button class="btn btn-xs btn-outline-primary"
                  (click)="$event.stopPropagation(); dropUser.close(); moveToSite('/profile')" placement="bottom"
                  tooltipClass="text-nowrap" [ngbTooltip]="'Edit profile'|translate">
                  <i class="fa-solid fa-pen"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Hide on mobile -->
          <div class="d-none d-md-block">
            <h6 class="dropdown-header" translate>Settings</h6>
            @if (!isViewerRole) {
              <button ngbDropdownItem (click)="moveToSite('/users')" translate>Users</button>
            }
            @if (isAdminOrHigher) {
              <button ngbDropdownItem (click)="moveToSite('/organizations')" translate>Organizations
              </button>
            }
            <button ngbDropdownItem (click)="moveToSite('/machines')" translate>Machines</button>
            <button ngbDropdownItem (click)="moveToSite('/machinegroups')" translate>Machinery groups</button>
            @if (isAdminOrHigher || isDistributorRole) {
              <button ngbDropdownItem (click)="moveToSite('/gateways')" translate>
                Gateways
              </button>
            }
            @if (isAdminOrHigher) {
              <button ngbDropdownItem (click)="moveToSite('/portalsetup')" translate>Machine categories</button>
            }
            <div class="dropdown-divider"></div>
          </div>

          <h6 class="dropdown-header">
            <span translate>Support</span>
            <i class="fa-solid fa-circle-info ml-1" placement="top" tooltipClass="text-nowrap"
            [ngbTooltip]="getPortalVersion()"></i>
          </h6>
          @if (supportTicketUrl) {
            <button ngbDropdownItem translate (click)="openSupportTicket()">Create ticket</button>
          }
          <button ngbDropdownItem translate (click)="openSupportContact()">Contact</button>
          @if (userManualUrl) {
            <button ngbDropdownItem translate (click)="openUserManual()">User Manual</button>
          }
          <button ngbDropdownItem translate (click)="openSupportDocumentation()">Documentation</button>
          <button (click)="openPolicyUrl()" [disabled]="hasInvalidPrivacyURL" class="target-blank" ngbDropdownItem
            translate>Privacy
          </button>
          <button (click)="openUserAgreementUrl()" [disabled]="hasInvalidUserAgreementURL" class="target-blank"
            ngbDropdownItem translate>
            Terms of Service
          </button>
          <button (click)="openLegalNotice()" ngbDropdownItem translate>Legal Notice</button>
          <div class="dropdown-divider"></div>

          <div class="form-row align-items-center">
            <div class="col">
              <button (click)="onLogout()" ngbDropdownItem>
                <em class="fa-solid fa-arrow-right-from-bracket"></em>
                <span translate>Logout</span>
              </button>
            </div>
            <div class="col-auto">
              <div #dropLang="ngbDropdown" class="d-inline-flex mr-2" ngbDropdown>
                <button (focus)="dropLang.open()"
                  class="btn btn-link btn-xs text-white dropdown-languages dropdown-no-arrow"
                  id="dropdownLanguages"
                  ngbDropdownAnchor>
                  <span [ngClass]="activeLanguageFlag"
                  class="flag"></span>
                </button>
                <div aria-labelledby="dropdownManual" ngbDropdownMenu>
                  @for (language of LANGUAGES; track language) {
                    <button (click)="changeLanguage(language.key)" ngbDropdownItem>
                      <span [ngClass]="language.flag"
                        class="flag">
                      </span>
                      &nbsp;
                      <span [innerText]="language.name | translate"></span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <scitis-notification
        [isPageVisible]="isVisible"
        [notificationRetention]="notificationRetention">
      </scitis-notification>
    </div>
  </div>
</header>
